module.exports = __webpack_public_path__ + "static/media/campbell3.888d7228.jpg";